// src/config/globalProperties.js

import axios from 'axios';
import messageService from '@/services/messages.js';

/**
 * Le a configuracao que o Laravel expoe em /config e /version antes do mount e
 * publica em window + globalProperties. Dois clients aqui, diferente do
 * accounts (que so fala com o liberty/auth): `API_AUTH` para sessao/appmenu, e
 * `API_SELF` para o /api/docs deste proprio backend -- mesma origem, por isso
 * baseURL vazia.
 */
export async function loadAppConfig(app) {
    try {
        const [configRes, versionRes] = await Promise.all([fetch('/config'), fetch('/version')]);

        const config = configRes.ok ? await configRes.json() : {};
        const versionJson = versionRes.ok ? await versionRes.json() : {};

        const finalConfig = {
            ...config,
            version: versionJson?.[config.APP_NAME]?.version,
        };

        app.config.globalProperties.APP_NAME = finalConfig.APP_NAME;
        app.config.globalProperties.APP_ENV = finalConfig.APP_ENV;
        app.config.globalProperties.URL_API_BASE_AUTH = finalConfig.URL_API_BASE_AUTH;
        app.config.globalProperties.URL_APP_ADMIN = finalConfig.URL_APP_ADMIN;
        app.config.globalProperties.APPMENU_CATALOG = finalConfig.APPMENU_CATALOG;
        app.config.globalProperties.API_ENV = finalConfig.API_ENV;
        app.config.globalProperties.version = finalConfig.version;
        app.config.globalProperties.message = messageService;

        window.appConfig = finalConfig;
        window.message = messageService;
        window.APP_ENV = finalConfig.APP_ENV;
        window.API_AUTH = axios.create({ baseURL: finalConfig.URL_API_BASE_AUTH || '' });
        window.API_SELF = axios.create({ baseURL: '/api' });

        return finalConfig;
    } catch (error) {
        console.error('Erro ao carregar configuracoes da aplicacao:', error);
        return null;
    }
}
